import { render, staticRenderFns } from "./ModalBulkSendRejectedEmailSingleAppointment.vue?vue&type=template&id=87ae99d2&"
import script from "./ModalBulkSendRejectedEmailSingleAppointment.vue?vue&type=script&lang=js&"
export * from "./ModalBulkSendRejectedEmailSingleAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAlert,VChip})
